import { ButtonGroup, Modal } from 'slab'

export function OnboardingClearEnrollmentsModal ({
  isModalOpen,
  onClose,
  onSubmit,
  description,
}: {
  isModalOpen: boolean,
  onClose: () => void,
  onSubmit: () => void,
  description: string,
}) {
  return (
    <Modal
      open={isModalOpen}
      onOpenChange={(open) => { if (!open) onClose() }}
    >
      <Modal.Body>
        <Modal.Title>Changing this will empty your cart</Modal.Title>
        <Modal.Description>
          {description}
        </Modal.Description>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Modal.Button variant='secondary' onClick={onClose}>
            Cancel
          </Modal.Button>
          <Modal.Button variant='primary' onClick={onSubmit}>
            Continue
          </Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
